import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsTop } from './components/TestimonialsTop';
import { ProductBonosSection } from './components/ProductBonosSection';
import { TestimonialsBottom } from './components/TestimonialsBottom';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { BotanicalDivider } from './components/BotanicalDivider';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-ivory font-sans text-ink relative pb-24 md:pb-0" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <BotanicalDivider data-id="element-4" />
        <PainSection data-id="element-5" />
        <BotanicalDivider data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <BotanicalDivider data-id="element-8" />
        <TestimonialsTop data-id="element-9" />
        <ProductBonosSection data-id="element-10" />
        <BotanicalDivider data-id="element-11" />
        <TestimonialsBottom data-id="element-12" />
        <BotanicalDivider data-id="element-13" />
        <FAQSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <StickyCTA data-id="element-16" />
    </div>;
}